// extracted by mini-css-extract-plugin
module.exports = {"litresAuthorLink":"AvthorDetail_litresAuthorLink__PnBCe"};